import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <div className="table">
      <table>
        <tr>
          <th className="col bor-bot" />
          <th>1e decl.</th>
          <th colSpan={2}>2e decl.</th>
          <th colSpan={2}>3e decl.</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>
            femin–
            <strong>a</strong>
          </td>
          <td>
            serv–
            <strong>us</strong>
          </td>
          <td>
            don–
            <strong>um</strong>
          </td>
          <td>rex</td>
          <td>nomen</td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>
            femin–
            <strong>ae</strong>
          </td>
          <td>
            serv–
            <strong>i</strong>
          </td>
          <td>
            don–
            <strong>i</strong>
          </td>
          <td>
            reg–
            <strong>is</strong>
          </td>
          <td>
            nomin–
            <strong>is</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>
            femin–
            <strong>ae</strong>
          </td>
          <td>
            serv–
            <strong>o</strong>
          </td>
          <td>
            don–
            <strong>o</strong>
          </td>
          <td>
            reg–
            <strong>i</strong>
          </td>
          <td>
            nomin–
            <strong>i</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>
          <td>
            femin–
            <strong>am</strong>
          </td>
          <td>
            serv–
            <strong>um</strong>
          </td>
          <td>
            don–
            <strong>um</strong>
          </td>
          <td>
            reg–
            <strong>em</strong>
          </td>
          <td>nomen</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">
            femin–
            <strong>a</strong>
          </td>
          <td className="bor-bot">
            serv–
            <strong>o</strong>
          </td>
          <td className="bor-bot">
            don–
            <strong>o</strong>
          </td>
          <td className="bor-bot">
            reg–
            <strong>e</strong>
          </td>
          <td className="bor-bot">
            nomin–
            <strong>e</strong>
          </td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>
            femin–
            <strong>ae</strong>
          </td>
          <td>
            serv–
            <strong>i</strong>
          </td>
          <td>
            don–
            <strong>a</strong>
          </td>
          <td>
            reg–
            <strong>es</strong>
          </td>
          <td>
            nomin–
            <strong>a</strong>
          </td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>
            femin–
            <strong>arum</strong>
          </td>
          <td>
            serv–
            <strong>orum</strong>
          </td>
          <td>
            don–
            <strong>orum</strong>
          </td>
          <td>
            reg–
            <strong>um</strong>
          </td>
          <td>
            nomin–
            <strong>um</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>
            femin–
            <strong>is</strong>
          </td>
          <td>
            serv–
            <strong>is</strong>
          </td>
          <td>
            don–
            <strong>is</strong>
          </td>
          <td>
            reg–
            <strong>ibus</strong>
          </td>
          <td>
            nomin–
            <strong>ibus</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>
            femin–
            <strong>as</strong>
          </td>
          <td>
            serv–
            <strong>os</strong>
          </td>
          <td>
            don–
            <strong>a</strong>
          </td>
          <td>
            reg–
            <strong>es</strong>
          </td>
          <td>
            nomin–
            <strong>a</strong>
          </td>
        </tr>
        <tr>
          <th className="col">abl. mv.</th>
          <td>
            femin–
            <strong>is</strong>
          </td>
          <td>
            serv–
            <strong>is</strong>
          </td>
          <td>
            don–
            <strong>is</strong>
          </td>
          <td>
            reg–
            <strong>ibus</strong>
          </td>
          <td>
            nomin–
            <strong>ibus</strong>
          </td>
        </tr>
      </table>
    </div>
    <p>
      <Letop>
        De nominativus enkelvoud in <strong>rex</strong> en de
        nominativus/accusativus enkelvoud in <strong>nomen</strong> hebben geen
        aparte uitgang. Dat komt omdat deze vormen onregelmatig zijn. Om de stam
        te bepalen moet je de meervoudsvorm leren (of opzoeken).
      </Letop>
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/znw-5.js